import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

export const getInboxCompOff = createAsyncThunk('inboxCompOff/getRequest', async (data) => {
    try {
        const response = await axios.post('/CompOffRequest/get-request', data, {
            headers: { 'Content-Type': 'application/json' }
        });

        return response?.data;
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateInboxCompOffRemarks = createAsyncThunk('inboxCompOff/updateRemarks', async (data) => {
    try {
        const response = await axios.put('/CompOffRequest/request-status/' + data?.id, data?.data, {
            headers: { 'Content-Type': 'application/json' }
        });

        toast.success(response?.data?.message || 'Status updated successfully.');
        return response?.data;
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

const inboxCompOffSlice = createSlice({
    name: 'inboxCompOff',
    initialState: {
        compOff: []
    },
    reducers: {
        removeInboxCompOff: (state) => {
            state.compOff = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getInboxCompOff.fulfilled, (state, action) => {
            state.compOff = action?.payload;
        });
    }
});

export const { removeInboxCompOff } = inboxCompOffSlice.actions;
export default inboxCompOffSlice.reducer;
